import { CSSProperties } from "react";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";

type Prop = JSX.IntrinsicElements["div"] & {
  minWidth: CSSProperties["minWidth"];
  minHeight?: CSSProperties["minHeight"];
  gridTemplateColumns: CSSProperties["gridTemplateColumns"];
};

export const SelectRowContainer = (props: Prop) => {
  const {
    children,
    gridTemplateColumns,
    minWidth,
    minHeight,
    ...rowContainerDivProps
  } = props;

  return (
    <div
      css={[rowContainer, { minWidth, minHeight }, { gridTemplateColumns }]}
      {...rowContainerDivProps}
    >
      {props.children}
    </div>
  );
};

const rowContainer = css({
  display: "grid",
  justifyContent: "center",
  alignItems: "center",
  background: color.white,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: color.iron,
  borderRadius: 8,
});
